import { create } from './instance'

export const { tw, setup } = create()
